export const decodeBase64Pcm16 = ({ bufferBase64 }: { bufferBase64: string }): Int16Array => {
  const bytes = Uint8Array.from(atob(bufferBase64), char => char.charCodeAt(0));
  const view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
  const sampleCount = Math.floor(bytes.byteLength / 2);
  const samples = new Int16Array(sampleCount);

  for (let sampleIndex = 0; sampleIndex < sampleCount; sampleIndex++) {
    samples[sampleIndex] = view.getInt16(sampleIndex * 2, true);
  }

  return samples;
};
